import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'jspdf-autotable';
import './Paymentdetails.css';
import Sidebar from '../../component/Sidebar';
import Cookies from 'js-cookie';
import { CSVLink } from 'react-csv';

export default function Payments() {
  const [data, setData] = useState([]);
  const [generateMonth, setGenerateMonth] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [genarateDate, setGenarateDate] = useState(''); 

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const token =Cookies.get('token');
        const response = await axios.get('https://hotfix-back-hris.talentfort.live/paymentdata/hemasmc',{
          headers: {
             Authorization: `Bearer ${token}`,
          },
        });
        setData(response.data); // Set data to the entire response
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchPayments();
  }, []);

  const handleCheckboxChange = (empNo) => {
    if (selectAll) {
      // If "Select All" is checked, toggle individual row selection
      const newSelectedRows = selectedRows.includes(empNo)
        ? selectedRows.filter((selectedEmpNo) => selectedEmpNo !== empNo)
        : [...selectedRows, empNo];
      setSelectedRows(newSelectedRows);
    } else {
      // Toggle individual row selection
      const newSelectedRows = [...selectedRows];
      const index = newSelectedRows.indexOf(empNo);
  
      if (index === -1) {
        newSelectedRows.push(empNo);
      } else {
        newSelectedRows.splice(index, 1);
      }
  
      setSelectedRows(newSelectedRows);
    }
  };
  
  const handleSelectAllChange = () => {
    setSelectAll(!selectAll);
    setSelectedRows(selectAll ? [] : data.map((payment) => payment.empNo));
  };
  
  const handleSave = async () => {
    try {
       // Validate if generateDate and generateMonth are selected
       if (!genarateDate ) {
        // If either generateDate or generateMonth is not selected, display an error message
        alert('Please select "Generate Date" before generating.');
        return;
      }
      if (!generateMonth) {
        // If either generateDate or generateMonth is not selected, display an error message
        alert('Please select "Payment Month" before generating.');
        return;
      }
      const unselectedData = data.filter((payment) => !selectedRows.includes(payment.empNo));
      const token =Cookies.get('token');
      // Send a single POST request with unselected payment data
      await axios.post('https://hotfix-back-hris.talentfort.live/payments', {
        payments: unselectedData,
        generateMonth: generateMonth,
        generateDate: genarateDate,
      },{
        headers: {
           Authorization: `Bearer ${token}`,
        }

      });

      // Display success alert before redirecting
      alert('Payment data saved successfully.');
      window.location.href = '/paymentreport';
    } catch (error) {
      console.error('Error saving unselected payment data:', error);
    }
  };
  const handleUpdate = async () => {
    try {
       // Validate if generateDate and generateMonth are selected
       if (!genarateDate ) {
        // If either generateDate or generateMonth is not selected, display an error message
        alert('Please select "Generate Date" before generating.');
        return;
      }
      if (!generateMonth) {
        // If either generateDate or generateMonth is not selected, display an error message
        alert('Please select "Payment Month" before generating.');
        return;
      }
      // Filter out the selected rows from the data
      const unselectedData = data.filter((payment) => !selectedRows.includes(payment.empNo));
      const token =Cookies.get('token');
       await axios.put('https://hotfix-back-hris.talentfort.live/payments', {
        payments: unselectedData,
        generateMonth: generateMonth,
        generateDate: genarateDate,
      },{
        headers: {
           Authorization: `Bearer ${token}`,
        }
        });
          alert('Payment data updated successfully.');
          window.location.href = '/paymentreport';
        
    } catch (error) {
      console.error('Error updating payment data:', error);
      alert('Failed to update payment data. Please check the console for details.');
    }
  };


  const prepareCSVData = () => {
    // Map the data to an array of arrays representing rows in the CSV
    const csvData = data.map((payment) => [
      payment.empNo,
      payment.epfNo,
      payment.displayName,
      parseFloat(payment.salary).toFixed(2),
      parseFloat(payment.payGrade).toFixed(2),
      parseFloat(payment.fixAllowance).toFixed(2),
      parseFloat(payment.consolidateSalary).toFixed(2),
      parseFloat(payment.nopayRate).toFixed(2),
      parseFloat(payment.noPay).toFixed(2),
      parseFloat(payment.nopayAmount).toFixed(2),
      parseFloat(payment.salaryArrears).toFixed(2),
      parseFloat(payment.grossAmount).toFixed(2),
      parseFloat(payment.attendenceAllowance).toFixed(2),
      parseFloat(payment.performanceAllowance).toFixed(2),
      parseFloat(payment.holidayPayment).toFixed(2),
      parseFloat(payment.transportAllowance).toFixed(2),
      parseFloat(payment.specialAllowance).toFixed(2),
      parseFloat(payment.otherReimbursement).toFixed(2),
      parseFloat(payment.salesCommission).toFixed(2),
      parseFloat(payment.advance).toFixed(2),
      parseFloat(payment.festivalAdvance).toFixed(2),
      payment.otherArrears,
      payment.otherAddition,
      parseFloat(payment.totalAllowance).toFixed(2),
      parseFloat(payment.totalEarning).toFixed(2),
      parseFloat(payment.festivaladvanceDeduction).toFixed(2),
      parseFloat(payment.advanceDeduction).toFixed(2),
      parseFloat(payment.epf8).toFixed(2),
      parseFloat(payment.stampDuty).toFixed(2),
      parseFloat(payment.payeetax).toFixed(2),
      parseFloat(payment.totalDeduction).toFixed(2),
      parseFloat(payment.netSalary).toFixed(2),
      parseFloat(payment.epf12).toFixed(2),
      parseFloat(payment.etf3).toFixed(2),
      payment.accountNo,
    ]);
  
    // Insert headers as the first row
    const headers = [
      "Emp No",
      "Epf No",
      "Emp Name",
      "Basic Salary",
      "Bud. Allowance",
      "Fix. Allowance",
      "Consolidate Salary",
      "Nopay Rate",
      "Nopay Hours",
      "Nopay Amount",
      "Salary Arrears",
      "Gross Salary",
      "Attendence Allowance",
      "Performance Allowance",
      "Holiday Payment",
      "Transport Allowance",
      "Special Allowance",
      "Other Reimbursement",
      "Sales Commission",
      "Salary Advance",
      "Festival Advance",
      "Other Arrears",
      "Other Additions",
      "Total Allowance",
      "Total Earning",
      "Festival Advance Deduction",
      "Advance Deduction",
      "EPF(8%)",
      "Stamp Duty",
      "Payee Tax",
      "Total Deduction",
      "Net Salary",
      "EPF(12%)",
      "ETF(3%)",
      "Account No",
    ];
  
    return [headers, ...csvData];
  };
  


  return (
    <div className='main-body'>
    <div>
    <Sidebar />
    </div>
      <div className="report">
        <h1>Payment Details (Hemas MC)</h1>
        <div className="row">
<div className="col-lg-3 mb-2">
  <label htmlFor="generateMonth" className="form-label">
    Payment Month
  </label>
  <input
    type="month"
    className="form-control"
    id="generateMonth"
    name="generateMonth"
    onChange={(e) => setGenerateMonth(e.target.value)}
  />
</div>
<div className="col-lg-3 mb-2">
  <label htmlFor="genarateDate" className="form-label">
    Genarate Date
  </label>
  <input
    type="date"
    className="form-control"
    id="genarateDate"
    name="genarateDate"
    onChange={(e) => setGenarateDate(e.target.value)} 
  />
</div>
</div>
        <div>
          <table className="table">
            <thead>
              <tr>
              <th>
                  <input
                    type="checkbox"
                    onChange={handleSelectAllChange}
                    checked={selectAll}
                  />
                </th>
                <th>Emp No</th>
                <th>Epf No</th>
                <th>Emp Name</th>
                <th>Basic Salary</th>
                <th>Bud. Allowance</th>
                <th>Consolidate Salary</th>
                <th>Nopay Rate</th>
                <th>Nopay Hours</th>
                <th>Nopay Amount</th>
                <th>Salary Arrears</th>
                <th>Gross Salary</th>
                <th>Attendence Allowance</th>
                <th>Performance Allowance</th>
                <th>Holiday Payment</th>
                <th>Transport Allowance</th>
                <th>Special Allowance</th>
                <th>Other Reimbursement</th>
                <th>Sales Commission</th>
                <th>Salary Advance</th>
                <th>Festival Advance</th>
                <th>Other Arrears</th>
                <th>Other Additions</th>
                <th>Total Allowance</th>
                <th>Total Earning</th>
                <th>Festival Advance Deduction</th>
                <th>Advance Deduction</th>
                <th>EPF(8%)</th>
                <th>Stamp Duty</th>
                <th>Payee Tax</th>
                <th>Total Deduction</th>
                <th>Net Salary</th>
                <th>EPF(12%)</th>
                <th>ETF(3%)</th>
                <th>Account No</th>             
              </tr>
            </thead>
            <tbody>
              {data.map((payment) => (
                <tr key={payment.empNo}>
                <td>
                 <input
                   type="checkbox"
                   onChange={() => handleCheckboxChange(payment.empNo)}
                   checked={selectedRows.includes(payment.empNo)}
                 />
               </td>
                  <td>{payment.empNo}</td>
                  <td>{payment.epfNo}</td>
                  <td>{payment.displayName}</td>
                  <td className="right-aligned">{parseFloat(payment.salary).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.payGrade).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.consolidateSalary).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.nopayRate).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.noPay).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.nopayAmount).toFixed(2)}</td>       
                  <td className="right-aligned">{parseFloat(payment.salaryArrears).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.grossAmount).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.attendenceAllowance).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.performanceAllowance).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.holidayPayment).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.transportAllowance).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.specialAllowance).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.otherReimbursement).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.salesCommission).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.advance).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.festivalAdvance).toFixed(2)}</td>
                  <td className="right-aligned">{payment.otherArrears}</td>
                  <td className="right-aligned">{payment.otherAddition}</td> 
                  <td className="right-aligned">{parseFloat(payment.totalAllowance).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.totalEarning).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.festivaladvanceDeduction).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.advanceDeduction).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.epf8).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.stampDuty).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.payeetax).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.totalDeduction).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.netSalary).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.epf12).toFixed(2)}</td>
                  <td className="right-aligned">{parseFloat(payment.etf3).toFixed(2)}</td>
                  <td className="right-aligned">{payment.accountNo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='hemasmc_buttons'> 
        <CSVLink
    data={prepareCSVData()} // Call prepareCSVData to get the formatted data
    filename={`Hemas_MC_check.csv`}
    className="checkcsv" // Add a className for styling
    target="_blank"
  >
    Check
  </CSVLink>
            <button className='update' onClick={handleUpdate}>Update </button>
            <button className='genarate' onClick={handleSave}>Generate </button>
          </div>
      </div>
    </div>
  );
}